var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportSalesActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3462 22.0786C22.3373 21.5964 21.6904 21.0714 21.6904 20.2893C21.6904 19.3893 22.587 18.7571 24.0738 18.7571C25.64 18.7571 26.2301 19.4643 26.2755 20.5143H28.2163C28.1595 19.0786 27.2289 17.7607 25.3903 17.3321V15.5H22.7459V17.3107C21.0322 17.6536 19.6589 18.7036 19.6589 20.3214C19.6589 22.2393 21.3499 23.2036 23.8127 23.7607C26.0259 24.2536 26.4685 24.9929 26.4685 25.7643C26.4685 26.3321 26.0259 27.2536 24.0851 27.2536C22.2692 27.2536 21.5542 26.4821 21.4521 25.4964H19.5C19.6135 27.3179 21.0435 28.3464 22.7459 28.6786V30.5H25.4016V28.7107C27.1267 28.4 28.4887 27.4679 28.5 25.7429C28.4887 23.3857 26.3436 22.5714 24.3462 22.0786Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportSalesActivity);
export default __webpack_public_path__ + "static/media/ic-report-sales-activity.636cd0bc6a9da85ebb3fb7dac24e343b.svg";
export { ForwardRef as ReactComponent };